import { useContext } from 'react';
import { NotificationsPopoverCloseContext } from './NotificationsPopoverCloseProvider';

/**
 * Returns the notifications popover close handler, or null outside the provider.
 */
export function useNotificationsPopoverClose(): (() => void) | null {
  return useContext(NotificationsPopoverCloseContext);
}
